/* eslint-disable react/prop-types */
import { SideNavItems as CarbonSideNavItems } from '@carbon/react';

export const SideNavItems = ({ children, ...props }) => (
  <CarbonSideNavItems {...props}>{children}</CarbonSideNavItems>
);
